import type { Query } from '@tanstack/react-query';
import { REGION_HIERARCHY_QUERY_PREFIX } from '../components/RegionHierarchyInput';

/**
 * Matches any cached query built by HierarchyInput for RegionHierarchyInput
 * (the parent-region picker actually rendered in Create/EditRegionModal).
 *
 * That picker keys its `items`/`path`/`children-check` queries as
 * `[\`${REGION_HIERARCHY_QUERY_PREFIX}{countryIds}-{selector}\`, ...]` — a
 * different shape from `regionKeys`, and one whose first segment varies per
 * country/selector combination. A plain `queryKey` filter can't partial-match
 * "all variants", so region mutations invalidate via this predicate instead.
 */
export function isRegionHierarchyQuery(query: Query): boolean {
  const firstKeySegment = query.queryKey[0];
  return (
    typeof firstKeySegment === 'string' && firstKeySegment.startsWith(REGION_HIERARCHY_QUERY_PREFIX)
  );
}
